<template>
  <div class="resource-box">
    <span class="power-add-title">{{typeTitle}}资源</span>
    <div style="width: 480px;" class="add-access m-t-20" v-loading="resLoading">
      <el-form :model="roleform" :rules="rules" ref="roleform" label-width="80px">
        <el-form-item label="权限名称" prop="resourceNameShow">
          <el-input v-model="roleform.resourceNameShow" placeholder="请输入权限名称"></el-input>
        </el-form-item>
        <el-form-item label="权限别名" prop="resourceName">
          <el-input v-model="roleform.resourceName" placeholder="请输入权限名称"></el-input>
        </el-form-item>
        <el-form-item label="页面类型" prop="isH5">
          <el-radio-group v-model="roleform.isH5">
            <el-radio :label="1">H5页面</el-radio>
            <el-radio :label="0">非H5页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设备类型" :span="11" prop="equipmentTypeName">
          <el-select v-model="roleform.equipmentType" @change="equipmentTypeLever" placeholder="请选择设备类型">
            <el-option v-for="pitem in equipmentTypeList" :key="pitem.id" :label="pitem.label" :value="pitem.id">
              {{pitem.label}}
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="权限类型" prop="extendTypeName">
          <el-select v-model="roleform.extendTypeName" @change="extendTypeLever" placeholder="请选择权限类型">
            <el-option v-for="pitem in extendTypeList" :key="pitem.id" :label="pitem.label" :value="pitem">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="小类型" prop="extendTypeName">
          <el-select v-model="roleform.resourceType" @change="resourceTypeLever" placeholder="请选择小类型">
            <el-option v-for="pitem in resourceTypeList" :key="pitem.id" :label="pitem.label" :value="pitem.id">
              {{pitem.label}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级名称" prop="parentId">
          <!-- <img src="https://direct-fired.oss-cn-beijing.aliyuncs.com/business_1596527617000.png?x-oss-process=image/resize,w_100" alt=""> -->
          <!-- <img src="http://image-demo.oss-cn-hangzhou.aliyuncs.com/example.jpg?x-oss-process=image/resize,w_100" alt=""> -->
          <el-cascader @click.native="geteResource(roleform.equipmentType)" :disabled="type === 1" ref="parent" @change="parentChange" clearable :props="{checkStrictly: true,emitPath: false, value: 'resourceId',children:'children',label:'resourceNameShow'}" v-model="roleform.parentId" :options="parentIdList"></el-cascader>
        </el-form-item>
        <el-form-item label="接口" prop="resourceUrl">
          <el-input v-model="roleform.resourceUrl" placeholder="请输入接口url"></el-input>
        </el-form-item>
        <el-form-item :span="11" label="是否展示" prop="isShowName">
          <el-select v-model="roleform.isShow" @change="isShowLever" placeholder="请选择是否展示">
            <el-option v-for="pitem in isShowList" :key="pitem.id" :label="pitem.label" :value="pitem.id">
              {{pitem.label}}
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="菜单图片" prop="imageUrl" v-if="addImgShow">
              <el-upload class="avatar-uploader" action="http://direct-fired.oss-cn-beijing.aliyuncs.com" :show-file-list="false" :before-upload="beforeAvatarUpload" accept="image/png,image/gif,image/jpg,image/jpeg" :http-request="upLoad">
                <div v-if="roleform.imageUrl">
                  <img width="150" height="100" :src="roleform.imageUrl" class="avatar">
                </div>
                <div v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item> -->
        <el-form-item label="权限描述" prop="remark">
          <el-input type="textarea" maxlength="200" :autosize="{ minRows: 3, maxRows: 5 }" show-word-limit v-model="roleform.remark"></el-input>
        </el-form-item>
        <el-form-item label="权限编码" prop="urlCode">
          <el-input type="textarea" maxlength="200" :autosize="{ minRows: 3, maxRows: 5 }" show-word-limit v-model="roleform.urlCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="form_btn" @click="cancel">取消</el-button>
          <el-button class="form_btn m-l-60" type="primary" @click="submitForm('roleform')">保存
            <!-- {{
        type===0?'添加':'编辑'
        }} -->
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import {
  Message
} from 'element-ui';
export default {
  name: "addCompany",
  data() {
    return {
      type: this.$route.query.type,
      // 阿里云相关 开始
      resLoading:false,
      // 阿里云相关 结束
      typeTitle: "添加",
      roleform: {
        id: 0,
        resourceNameShow: "",
        resourceName: "",
        resourceType: "",
        parentId: "",
        isH5: 0,
        isShow: "",
        imageUrl: "",
        resourceUrl: "",
        urlCode: "",
        equipmentType: "",
        extendType: "",
        remark: "",
        equipmentTypeName: "",
        resourceTypeName: "",
        isShowName: "",
        extendTypeName: "",
      },
      // editLoading: false,
      rules: {
        resourceNameShow: [
          { required: true, message: "请输入权限名称", trigger: "blur" },
        ],
        resourceName: [
          { required: true, message: "请输入权限别名", trigger: "blur" },
        ],
        // resourceUrl: [
        //   { required: true, message: "请输入接口url", trigger: "blur" },
        // ],
        equipmentTypeName: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        // resourceTypeName: [
        //   { required: true, message: '请选择小类型', trigger: 'change' }
        // ],
        isShowName: [
          { required: true, message: "请选择是否展示", trigger: "change" },
        ],
        isH5: [
          { required: true, message: "请选择页面类型", trigger: "change" },
        ],
        // imageUrl: [
        //   { required: true, message: '请选择菜单图片', trigger: 'change' }
        // ],
        // extendTypeName: [
        //   { required: true, message: '请选择权限类型', trigger: 'change' }
        // ]
      },
      isShowList: [
        { label: "不展示", id: 0 },
        { label: "展示", id: 1 },
      ],
      equipmentTypeList: [
        { label: "app", id: 1 },
        { label: "web", id: 2 },
      ],
      resourceTypeList: [
        { label: "平台", id: 1 },
        { label: "子系统", id: 2 },
        { label: "模块", id: 3 },
        { label: "菜单", id: 4 },
        { label: "功能", id: 5 },
        { label: "按钮", id: 6 },
        { label: "菜单下按钮", id: 7 },
      ],
      parentIdList: [],
    };
  },
  created() {
    this.type = this.$route.query.type;
   const titleArr = { 0: "添加", 1: "编辑" };
      this.typeTitle = titleArr[this.type];
    if (this.$route.query.type === "1") {
      this.getEditList(this.$route.query.id);
    }
  },
  methods: {
    // 编辑接口获取相关数据
    getEditList(id) {
      const that = this;
      that.resLoading=true
      const params = { resourceId: id };
      let url = "bma-user-service/resource/searchResourceDetail";
      that.$http
        .post(url, params)
        .then(function (res) {
          const data = res.data;
          that.roleform.id = data.id;
          that.roleform.resourceNameShow = data.resourceNameShow;
          that.roleform.resourceName = data.resourceName;
          that.roleform.resourceType = data.resourceType;
          that.roleform.parentId = data.parentId;
          that.roleform.imageUrl = data.imageUrl;
          that.roleform.isH5 = data.isH5;
          that.roleform.isShow = data.isShow;
          that.roleform.resourceUrl = data.resourceUrl;
          that.roleform.urlCode = data.urlCode;
          that.roleform.equipmentType = data.equipmentType;
          that.roleform.extendType = data.extendType;
          that.roleform.remark = data.remark;
          that.geteResource(data.equipmentType);
          that.roleform.equipmentTypeName = that.equipmentTypeFormat(
            data.equipmentType
          );
          that.roleform.resourceTypeName = that.resourceTypeFormat(
            data.resourceType
          );
          that.roleform.isShowName = that.isShowFormat(data.isShow);
          // 17
          // console.log(that.roleform.imageUrl);
           that.resLoading=false
        })
        .catch(function (err) {
          that.resLoading=false
          // console.log(err);
        });
    },
    // 获取父级菜列表
    geteResource(type) {
      const that = this;
      if (type) {
        let url = "bma-user-service/resource/searchResourceTree";
        that.$http
          .post(url, { equipmentType: type })
          .then(function (res) {
            that.parentIdList = that.reduceList(res.data, 0);
            // console.log(that.parentIdList);
          })
          .catch(function (err) {
            // console.log(err);
          });
      } else {
        Message.error("请先选择设备类型");
      }
    },
    // 多维数组扁平化数组
    reduceList(arr, level) {
      let filterDate = [];
      arr.forEach((v, k) => {
        if (v.children !== undefined && v.children.length > 0) {
          v.children = this.reduceList(v.children, level + 1);
        } else {
          delete v.children;
        }
        filterDate.push(v);
      });
      return filterDate;
    },
    // 选择父级菜单
    parentChange(v, e) {
      this.roleform.parentId = v;
    },
    // 取消
    cancel() {
      this.dialogUserVisible = false;
      this.$router.go(-1);
    },
    // 上传图片相关接口
    handlePictureCardPreview(file) {
      // console.log(file);
      this.dialogImageUrl = this.imageUrl;
      this.dialogVisible = true;
    },
    // 提交添加人员
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // // console.log('验证成功')
          this.submitList();
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // 提交选择的项目
    submitList() {
      const that = this;
      const urlMap = {
        0: "bma-user-service/resource/addResource",
        1: "bma-user-service/resource/updateResource",
      };
      const upParams = {
        equipmentType: that.roleform.equipmentType,
        extendType: that.roleform.extendType,
        id: that.roleform.id,
        imageUrl: that.roleform.imageUrl,
        isH5: that.roleform.isH5,
        isShow: that.roleform.isShow,
        parentId: that.roleform.parentId,
        remark: that.roleform.remark,
        resourceName: that.roleform.resourceName,
        resourceNameShow: that.roleform.resourceNameShow,
        resourceType: that.roleform.resourceType,
        resourceUrl: that.roleform.resourceUrl,
        status: that.roleform.status,
        urlCode: that.roleform.urlCode,
      };
      // console.log(qs.stringify(upParams));
      // urlMap[that.type](upParams)
      let url = urlMap[that.type];
      that.$http
        .post(url, {
          equipmentType: that.roleform.equipmentType,
          extendType: that.roleform.extendType,
          id: that.roleform.id,
          imageUrl: that.roleform.imageUrl,
          isH5: that.roleform.isH5,
          isShow: that.roleform.isShow,
          parentId: that.roleform.parentId,
          remark: that.roleform.remark,
          resourceName: that.roleform.resourceName,
          resourceNameShow: that.roleform.resourceNameShow,
          resourceType: that.roleform.resourceType,
          resourceUrl: that.roleform.resourceUrl,
          status: that.roleform.status,
          urlCode: that.roleform.urlCode,
        })
        .then(function (res) {
         // console.log(res)
          Message({
            showClose: true,
            message: res.data,
            type: "success",
          });
          that.$router.go(-1);
        })
        .catch(function (err) {
          // console.log(err);
        });
    },
    resourceTypeFormat(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 1:
          SwitchName = "平台";
          break;
        case 2:
          SwitchName = "子系统";
          break;
        case 3:
          SwitchName = "模块";
          break;
        case 4:
          SwitchName = "菜单";
          break;
        case 5:
          SwitchName = "功能";
          break;
        case 6:
          SwitchName = "按钮";
          break;
        case 7:
          SwitchName = "菜单下按钮";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    isH5Format(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 0:
          SwitchName = "不是";
          break;
        case 1:
          SwitchName = "是";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    isShowFormat(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 0:
          SwitchName = "不展示";
          break;
        case 1:
          SwitchName = "展示";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    equipmentTypeFormat(row, column, cellValue) {
      let SwitchName = "";
      switch (cellValue) {
        case 1:
          SwitchName = "app";
          break;
        case 2:
          SwitchName = "web";
          break;
        default:
          SwitchName = " ";
      }
      return SwitchName;
    },
    resourceTypeLever(val) {
      this.roleform.resourceType = val;
      this.roleform.resourceTypeName = this.resourceTypeFormat(0, val);
      if (val.id === 4) {
        this.addImgShow = true;
      } else {
        this.addImgShow = false;
      }
    },
    isShowLever(val) {
      this.roleform.isShow = val;
      this.roleform.isShowName = this.isH5Format(0,val);
    },
    equipmentTypeLever(val) {
      this.roleform.equipmentType = val;
      this.roleform.equipmentTypeName = this.equipmentTypeFormat(0,val);
    },
  },
  watch: {
    type(v) {
      const titleArr = { 0: "添加", 1: "编辑" };
       // console.log(v);
      this.typeTitle = titleArr[v];
     
      // console.log(this.typeTitle);
      if (v === 0) {
        this.roleform = {
          id: 0,
          resourceName: "",
          resourceNameShow: "",
          resourceType: "",
          parentId: "",
          isH5: 0,
          isShow: "",
          imageUrl: "",
          resourceUrl: "",
          urlCode: "",
          equipmentType: "",
          extendType: "",
          remark: "",
          equipmentTypeName: "",
          resourceTypeName: "",
          isShowName: "",
          extendTypeName: "",
        };
      }
    },
  },
};
</script>
<style lang="css">
.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}
.power-add-title {
  font-size: 16px;
  font-weight: 700;
}
.resource-box {
  margin: 25px 90px;
}

.avatar-uploader .el-upload {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  width: 178px;
  height: 178px;
  font-size: 28px;
  line-height: 178px;
  color: #8c939d;
  text-align: center;
}

.avatar {
  display: block;
  width: 178px;
  height: 178px;
}
.m-t-20 {
  margin-top: 20px;
}
</style>
